import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'default' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'default',
  size = 'md',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-heading font-bold transition-colors duration-200 rounded-sm focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-accent text-white hover:bg-red-700 focus:ring-accent',
    secondary: 'bg-transparent border-2 border-white text-white hover:bg-white/10 focus:ring-white',
    default: 'bg-btn text-white hover:bg-btn-hover focus:ring-btn',
    outline: 'bg-transparent border-2 border-accent text-accent hover:bg-accent hover:text-white focus:ring-accent'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg uppercase tracking-wide'
  };
  const width = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${width} ${className}`} {...props} data-id="element-465">
      {children}
    </button>;
}